import axios from './axios';
import { OKTA_API_URL } from '../constants';
import { AxiosInstance } from 'axios';

const oktaAxiosInstance = axios.create({
  baseURL: OKTA_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

let client: AxiosInstance | null = null;

const getInstance = (): AxiosInstance => {
  if (client === null) {
    client = oktaAxiosInstance;
  }
  return client;
};

export default getInstance();
